import type { IMappingValidationIssue, IMappingValidationResult } from "../../customTypings/spreadsheetTemplate/SpreadsheetTemplate";
import { WasteReturnRegFieldKeys } from "../../customTypings/spreadsheetTemplate/SpreadsheetTemplate";

/** Non-actionable mapping validation warnings hidden from Validate & save UI (underlying data unchanged). */
export const USER_FACING_EXCLUDED_MAPPING_VALIDATION_WARNING_CODES = new Set([
    "ProtectedSheet",
    "FormulaCell",
    "MergedCellsPresent",
]);

const GEOGRAPHY_ADJACENT_FIELD_GUIDANCE: Record<string, string> = {
    code: "Specify which column contains the geography code.",
    description: "Specify which column contains the geography description.",
    type: "Specify which column contains the geography type (District, Region, or Sub-Region).",
};

export function shouldDisplayMappingValidationWarning(issue: IMappingValidationIssue): boolean {
    return !USER_FACING_EXCLUDED_MAPPING_VALIDATION_WARNING_CODES.has(issue.code);
}

export function getDisplayedMappingValidationWarnings(
    validation: IMappingValidationResult
): IMappingValidationIssue[] {
    return validation.warnings.filter(shouldDisplayMappingValidationWarning);
}

export function getDisplayedMappingValidationWarningCount(validation: IMappingValidationResult): number {
    return getDisplayedMappingValidationWarnings(validation).length;
}

export function isExportReadyForDisplay(validation: IMappingValidationResult): boolean {
    return validation.isValid && getDisplayedMappingValidationWarningCount(validation) === 0;
}

export function formatMappingValidationWarningMessage(issue: IMappingValidationIssue): string {
    if (
        issue.code === "InvalidMappingShape" &&
        issue.section === "listSources" &&
        issue.fieldKey === WasteReturnRegFieldKeys.Geography
    ) {
        const match = issue.message.match(/adjacentColumnMap '(\w+)'/i);
        if (match) {
            const adjacentKey = match[1].toLowerCase();
            const guidance = GEOGRAPHY_ADJACENT_FIELD_GUIDANCE[adjacentKey];
            if (guidance) {
                return `Geography list source: ${guidance}`;
            }
        }

        return "Geography list source is incomplete. Map the code, description, and type columns in the list source configuration.";
    }

    return issue.message;
}
